/*
 * Copyright 1997 - ${YEAR} Scientific Learning Corporation.
 *
 * All rights reserved. Redistribution or copying of this source code is prohibited.
 * The binary code may be distributed only under and pursuant to the terms of a
 * license agreement agreed to by Scientific Learning Corporation or one of its
 * authorized distributors.
 */
import {Component, Injector, Inject} from "@angular/core";
import {ClientConfiguration} from "./services/configuration/client.config";
import {NavigationEvent} from "./event/NavigationEvent";
import {EventBus} from "./event/EventBus";
import {DOCUMENT} from "@angular/common";


@Component({
               selector: "hide-ra",
               template: ""
           })
export class HideRAComponent {

    constructor(private config: ClientConfiguration,
                private eventBus: EventBus,
                @Inject(DOCUMENT) private document: any) {

        if (this.config.allowBrowserVersion) {
            this.handleBrowserRedirect();
        }
    }

    private handleBrowserRedirect(): void {
        let referrer: string = this.document.referrer.replace(window.location.origin + "/", "");
        let referrerValid: boolean = referrer == "hide" || referrer == "" || referrer == "rav2/index.html";

        if (this.config.allowBrowserVersion && referrerValid) {
            this.eventBus.next(new NavigationEvent(["library"]));
        } else {
            this.eventBus.next(new NavigationEvent([referrer]));
        }
    }
}
